import rwd from '../../assets/Certificates/ResponsiveWebDesign.png';
import c_basic from '../../assets/Certificates/C(Basic).png';
import python_basic from '../../assets/Certificates/Python(Basic).png';
import c_intermediate from '../../assets/Certificates/C(Intermediate).png';
import java_basic from '../../assets/Certificates/Java(Basic).png';
import java_intermediate from '../../assets/Certificates/Java(Intermediate).png';
import javascript_basic from '../../assets/Certificates/Javascript(Basic).png';
import problemsolving_basic from '../../assets/Certificates/ProblemSolving(Basic).png';
import react_basic from '../../assets/Certificates/React(Basic).png';

export const certificationsText="CERTIFICATIONS";

export const cerifications=[{
    name:"Responsive Web Design",
    src:rwd
},{
    name:"C(Basic)",
    src:c_basic
},{
    name:"C(Intermediate)",
    src:c_intermediate
},{
    name:"Java(Basic)",
    src:java_basic
},{
    name:"Java(Intermediate)",
    src:java_intermediate
},{
    name:"Javascript(Basic)",
    src:javascript_basic
},{
    name:"ProblemSolving(Basic)",
    src:problemsolving_basic
},{
    name:"Python(Basic)",
    src:python_basic
},{
    name:"React(Basic)",
    src:react_basic
}];
